import { useInvitationStoreSelector } from '@/contexts/invitation-context';
import { useEmailIntegrationStatus } from './use-email-integration-status';
import { useEmailAttachments } from './use-email-attachments';

/** The provider owns the draft so back/forward navigation preserves its files. */
export function useInvitationEmailAttachments() {
  const draft = useInvitationStoreSelector((state) => state.emailAttachmentDraft);
  const updateDraft = useInvitationStoreSelector((state) => state.updateEmailAttachmentDraft);
  const { emailIntegration } = useEmailIntegrationStatus();
  return useEmailAttachments({ draft, updateDraft, provider: emailIntegration?.platform });
}
